import { postFeatureFlag } from '@gonfalon/openapi/operations/postFeatureFlag';
import { getQueryClient } from '@gonfalon/react-query-client/getQueryClient';

import { createMutationHook } from '../internal/createMutationHook';
import { getFeatureFlagsQuery } from '../queries/flags';

export const useCreateFlag = createMutationHook(postFeatureFlag, {
  onSuccess: async () => {
    const queryClient = getQueryClient();
    await queryClient.invalidateQueries({ queryKey: getFeatureFlagsQuery.partialQueryKey() });
  },
});
